<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
  Opret bruger med brik, med invitation
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<form [formGroup]="userFormGroup" (ngSubmit)="save()">
  <mat-dialog-content>
    <div class="feedback-dialog-container">
      <ok-feedback-info>
        <div>
          <strong>Info omkring oprettelse</strong>
          <br />
          Brugeren modtager en email med link til formular, hvor de skal udfylde personlig information.
        </div>
      </ok-feedback-info>
    </div>
    <div class="form-row">
      <adm-org-typeahead
        [initialId]="data.organization ? data.organization.id : undefined"
        [resetTrigger]="resetOrgTrigger()"
        (itemSelected)="organizationSelected($event)"
        (clearTypeAhead)="resetOrganization()" />
    </div>
    <div class="form-row">
      @let selectedDepartment = userFormGroup.controls.department.value;
      <adm-dep-typeahead
        [organizationId]="userFormGroup.controls.organization.value?.id ?? null"
        [departmentId]="selectedDepartment ? selectedDepartment.id.toString() : null"
        [disabled]="departmentsDisabled()"
        (itemSelected)="departmentSelected($event)"
        [resetTrigger]="resetDepartmentTrigger()" />
    </div>
    <div class="form-row">
      <h2 class="form-headline">Har brugeren firmabil?</h2>
      <mat-radio-group formControlName="userHasOrganizationCar" name="userHasOrganizationCar" class="padding--top-none">
        <mat-radio-button [value]="true">
          <span>Ja</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span>Nej</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Vælg adgangsgrupper</mat-label>
        <mat-select required [formControl]="userFormGroup.controls.selectedAccessGroups" multiple okCustomDropDownArrowDirective>
          <mat-select-trigger>
            {{ userFormGroup.controls.selectedAccessGroups.value[0]?.name || '' }}
            @if (userFormGroup.controls.selectedAccessGroups.value.length > 1) {
              <span class="example-additional-selection">
                (+{{ userFormGroup.controls.selectedAccessGroups.value.length - 1 }}
                {{ userFormGroup.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
              </span>
            }
          </mat-select-trigger>
          @for (accessGroup of accessGroups$ | async; track accessGroup) {
            <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix chip-input">
        <mat-label>Email(s) *</mat-label>
        <mat-chip-grid #chipGrid>
          @for (email of userFormGroup.controls.emails.controls; track email) {
            <mat-chip-row (removed)="remove(email)" [editable]="false" (matChipInputTokenEnd)="add($event)">
              {{ email.value }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          matInput
          placeholder="Ny email..."
          [matChipInputFor]="chipGrid"
          [formControl]="emailsInputControl"
          (paste)="emailsPaste($event)"
          (matChipInputTokenEnd)="add($event)"
          (blur)="onEmailBlur($event)"
          (input)="onEmailInput($event)" />

        <mat-hint
          class="alternative-hint"
          [class.hidden]="
            (emailInputTouched() && invalidEmailInput()) ||
            (userFormGroup.controls.emails.invalid && userFormGroup.controls.emails.hasError('minLength') && emailInputTouched())
          "
          >Indtast email og tryk enter, eller copy/paste mange emails og tryk enter
        </mat-hint>
      </mat-form-field>
      <mat-error
        [class.visible]="
          userFormGroup.controls.emails.invalid && userFormGroup.controls.emails.hasError('minLength') && emailInputTouched()
        "
        class="alternative-error"
        >Indtast mindst én email
      </mat-error>
      <mat-error [class.visible]="emailInputTouched() && invalidEmailInput()" class="alternative-error">Indtast en gyldig email</mat-error>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button mat-dialog-close>Annuller</button>
    <button class="actions__button" type="submit" mat-flat-button color="primary" [disabled]="userFormGroup.invalid">Gem</button>
  </mat-dialog-actions>
</form>
